/** @format */

import { filter } from 'rxjs/operators';
/** @format */

import { Injectable } from '@angular/core';
import * as firebase from 'firebase';
import * as moment from 'moment';
import { first, map, switchMap } from 'rxjs/operators';
// import { AdmissionHistory } from '../models/admissionHistory.model';
// import { PointDetail } from '../models/pointDetail.model';
// import { Studio } from '../models/studio.models';
import { User } from '../models/user.models';
import { DbService, getPaymentUser, leftJoinDocument } from './db.service';
import { Observable, combineLatest, defer, of, pipe } from 'rxjs';
import { CommonService } from './common.service';
import { Grade } from '../models/grade.model';
import { AdmissionHistory } from '../models/admissionHistory.model';
import { PumseMovement } from '../models/pumseMovements.model';
import { Pumse } from '../models/pumse.model';
import { Studio } from '../models/studio.models';
import { LanguageService } from './language.service';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  characterEdus;
  webtoons;
  grades;
  programData;
  pumseData;
  master;
  gradesData;
  lang: string;

  constructor(
    public db: DbService,
    //  public auth: AuthService,
    private common: CommonService,
    private languageService: LanguageService
  ) {
    console.log('DataService');
    this.initialData();
    this.languageService.currentLang.subscribe((lang) => {
      this.lang = lang;
    });
  }

  getPumsemMovementYoutubeUrlById(pumseId: string) {
    if (this.pumseData) {
      let selectPumse: Pumse = this.pumseData.find(
        (item) => item.id == pumseId
      );
      return selectPumse.movementYoutubeUrl;
    }
  }

  getCharacterEdus(): Promise<any> {
    return new Promise<any>(async (resolve) => {
      if (this.characterEdus) {
        resolve(this.characterEdus);
      } else {
        this.characterEdus = await this.getCharaters();
        resolve(this.characterEdus);
      }
    });
  }

  async initialData() {
    console.log('initialData');
    this.webtoons = await this.getWebtoons();
    this.grades = await this.getGrades();
    this.programData = await this.getPrograms();
    this.pumseData = await this.pumses();
    this.master = await this.getMasterData();
    console.log('this.master', this.master);

    this.characterEdus = await this.getCharaters();
    this.gradesData = await this.getGrades();
  }

  getMasterData(): Promise<any> {
    return this.db.doc$('master/master').pipe(first()).toPromise();
  }

  getCharaters(): Promise<any> {
    return this.db
      .collection$('characterEdus', (ref) =>
        ref
          .where('studioId', '==', this.master.masterStudioId)
          .orderBy('month', 'asc')
      )
      .pipe(first())
      .toPromise();
  }

  getGrades(): Promise<any> {
    return this.db
      .collection$('grades', (ref) => ref.orderBy('order', 'asc'))
      .pipe(first())
      .toPromise();
  }

  getWebtoons(): Promise<any> {
    return this.db
      .collection$('webtoons', (ref) =>
        ref.orderBy('month', 'asc').orderBy('episode', 'asc')
      )
      .pipe(first())
      .toPromise();
  }

  getWebtoonsByCharacterId(characterId: string) {
    return this.webtoons.filter((item) => item.characterId === characterId);
  }

  getSingleWebtoonById(wentoonId: string) {
    return this.webtoons.find((item) => item.id === wentoonId);
  }

  getSingleCharaterById(characterId: string) {
    return this.characterEdus.find((item) => item.id === characterId);
  }

  getGradeById(gradeId: string) {
    const grade = this.grades.find((item) => item.id === gradeId);
    return grade;
  }

  // getDisplayType(studio: Studio, user: User) {
  //   let isBlock = studio.blockUsers.find(item => item === user.id);
  //   if (isBlock) {
  //     return '차단회원';
  //   }

  //   let isStop = studio.stopUsers.find(item => item === user.id);
  //   if (isStop) {
  //     return '수련중지';
  //   }

  //   let isManager = studio.managerId.find(item => item === user.id);
  //   if (isManager) {
  //     return '매니저';
  //   }

  //   let isMaster = this.checkIsMaster(user.grade);
  //   if (isMaster) {
  //     return '교범';
  //   }

  //   return '일반회원';
  // }

  checkIsMaster(gradeId: string) {
    const grade = this.getGradeById(gradeId);

    if (!grade) {
      return false;
    }

    if (grade.order > 24) {
      return true;
    }
    return false;
  }

  getGradeName(user: User) {
    let grade = this.getGradeById(user.grade);
    if (user.birth) {
      const age = this.getAge(user);
      if (age > 19) {
        return grade.stepName
          ? grade.adultGradeName + ' ' + grade.stepName
          : grade.adultGradeName;
      } else {
        return grade.stepName
          ? grade.gradeName + ' ' + grade.stepName
          : grade.gradeName;
      }
    } else {
      return grade.stepName
        ? grade.gradeName + ' ' + grade.stepName
        : grade.gradeName;
    }
  }

  getOrder(user: User) {
    let grade = this.getGradeById(user.grade);

    return grade.order;
  }

  getAllGradesByUserAge(user: User) {
    let grades = this.gradesData.map((grade) => {
      let gradeName = '';
      if (user.birth) {
        const age = this.getAge(user);
        if (age > 19) {
          gradeName = grade.stepName
            ? grade.adultGradeName + ' ' + grade.stepName
            : grade.adultGradeName;
        } else {
          gradeName = grade.stepName
            ? grade.gradeName + ' ' + grade.stepName
            : grade.gradeName;
        }
      } else {
        gradeName = grade.stepName
          ? grade.gradeName + ' ' + grade.stepName
          : grade.gradeName;
      }
      return { gradeName, id: grade.id };
    });
    return grades;
  }

  getShortGradeName(user: User) {
    let grade = this.getGradeById(user.grade);
    if (user.birth) {
      const age = this.getAge(user);
      if (age > 19) {
        return grade.adultGradeName;
      } else {
        return grade.gradeName;
      }
    } else {
      return grade.gradeName;
    }
  }

  getDisplaySex(user: User) {
    if (user.sex === 'male') {
      return '남';
    }
    return '여';
  }

  getAge(user: User) {
    if (user.birth) {
      const age = moment().diff(user.birth, 'years') + 1;
      return age;
    }
    return 0;
  }
  async getAllpointDeatilByStudioId(studioId): Promise<any> {
    const giveRef = this.db.collection$('pointDetails', (ref) =>
      ref.where('providerId', '==', studioId)
    );
    const recieveRef = this.db.collection$('pointDetails', (ref) =>
      ref.where('recieverId', '==', studioId)
    );

    const allData = combineLatest<any[]>(giveRef, recieveRef).pipe(
      map((arr) => {
        const newArray = arr.reduce((acc, cur) => acc.concat(cur));
        return newArray.sort(
          (a, b) =>
            new Date(b.dateCreated).getTime() -
            new Date(a.dateCreated).getTime()
        );
      })
    );
    return allData.pipe(first()).toPromise();
  }

  getGivePointDetailByStudioId(studioId): Promise<any> {
    return this.db
      .collection$('pointDetails', (ref) =>
        ref.where('providerId', '==', studioId).orderBy('dateCreated', 'desc')
      )
      .pipe(first())
      .toPromise();
  }

  getRecievePointDetailByStudioId(studioId): Promise<any> {
    return this.db
      .collection$('pointDetails', (ref) =>
        ref.where('recieverId', '==', studioId).orderBy('dateCreated', 'desc')
      )
      .pipe(first())
      .toPromise();
  }

  getAdmissionReqeustsByUserId(userId: string): Promise<any> {
    return this.db
      .collection$('admissionRequests', (ref) =>
        ref.where('userId', 'array-contains', userId)
      )
      .pipe(first())
      .toPromise();
  }

  getEssentialTraingPeriod(user: User) {
    let trainingPeriod = this.master.trainingPeriod;
    let fullPeriod = 0;
    if (user.birth) {
      const age = this.getAge(user);
      if (age > 19) {
        fullPeriod = trainingPeriod.normal;
      } else {
        fullPeriod = trainingPeriod.children;
      }
    } else {
      fullPeriod = trainingPeriod.normal;
    }
    return fullPeriod;
  }

  getPumseMovements(userId: string): Promise<any> {
    return this.db
      .collection$('pumseMovements', (ref) => ref.where('userId', '==', userId))
      .pipe(first())
      .toPromise();
  }

  getAdmissionHistoryByUserId(userId: string): Promise<any> {
    return this.db
      .collection$('admissionHistory', (ref) =>
        ref.where('userId', '==', userId).orderBy('dateCreated', 'asc')
      )
      .pipe(first())
      .toPromise();
  }

  getGradePeriodById(gradeId: string) {
    if (!gradeId) {
      gradeId = 'H7nZlQnYADpcBoxKVxAL';
    }

    const grade = this.gradesData.find((item) => item.id === gradeId);
    if (!grade) {
      return 0;
    }

    if (grade.isStep) {
      return grade.periodMonth * 4;
    }
    return grade.periodMonth;
  }

  getGradeHistorys(user: User): Promise<any> {
    return this.db
      .collection$('gradeHistorys', (ref) =>
        ref.where('userId', '==', user.id).where('gradeId', '==', user.grade)
      )
      .pipe(first())
      .toPromise();
  }

  getAllUserTraingHistory(userId: string): Promise<any> {
    return this.db
      .collection$('trainingHistorys', (ref) =>
        ref.where('userId', '==', userId)
      )
      .pipe(first())
      .toPromise();
  }

  async updateMovement(
    userId: any,
    pumseId: string,
    movementIndex: number,
    isUpdate: boolean
  ) {
    let pumseMovement: PumseMovement = await this.getPumseMovementByPumseId(
      userId,
      pumseId
    );
    if (isUpdate) {
      if (pumseMovement) {
        return this.db.updateAt(`pumseMovements/${pumseMovement.id}`, {
          checkMovements:
            firebase.default.firestore.FieldValue.arrayUnion(movementIndex),
        });
      } else {
        pumseMovement = {
          dateCreated: new Date().toISOString(),
          userId,
          pumseId,
          checkMovements: [movementIndex],
        };

        return this.db.updateAt('pumseMovements', pumseMovement);
      }
    } else {
      return this.db.updateAt(`pumseMovements/${pumseMovement.id}`, {
        checkMovements:
          firebase.default.firestore.FieldValue.arrayRemove(movementIndex),
      });
    }
  }

  getPumseMovementByPumseId(userId: string, pumseId: string): Promise<any> {
    return this.db
      .collection$('pumseMovements', (ref) =>
        ref.where('userId', '==', userId).where('pumseId', '==', pumseId)
      )
      .pipe(
        map((arr) => {
          console.log('arr: ', arr);
          return arr && arr[0];
        }),
        first()
      )
      .toPromise();
  }

  getTestDetailByUserId(userId: string): Promise<any> {
    return this.db
      .collection$('testDetails', (ref) => ref.where('userId', '==', userId))
      .pipe(first())
      .toPromise();
  }

  async getStudioIdById(studioId: string): Promise<any> {
    return this.db.doc$(`studios/${studioId}`).pipe(first()).toPromise();
  }

  getUserTraingHistorybyUserId(userId: string): Promise<any> {
    const year = moment().format('YYYY');
    const month = moment().format('MM');
    return this.db
      .collection$('trainingHistorys', (ref) =>
        ref
          .where('userId', '==', userId)
          .where('year', '==', year)
          .where('month', '==', month)
      )
      .pipe(
        map((arr) => arr && arr[0]),
        first()
      )
      .toPromise();
  }

  getUserGradeHistorys(userId: string): Promise<any> {
    return this.db
      .collection$(`gradeHistorys`, (ref) =>
        ref.where('userId', '==', userId).orderBy('dateCreated', 'desc')
      )
      .pipe(first())
      .toPromise();
  }

  getUserGradeHistoryByuser(user: User): Promise<any> {
    return this.db
      .collection$(`gradeHistorys`, (ref) =>
        ref.where('userId', '==', user.id).where('gradeId', '==', user.grade)
      )
      .pipe(
        map((arr) => arr && arr[0]),
        first()
      )
      .toPromise();
  }

  getUserGradePeriod(user: User) {
    return new Promise<any>(async (resolve, reject) => {
      let userGradeHistorys = await this.getGradeHistorys(user);
      let userGradeHistory = userGradeHistorys[0];
      if (userGradeHistorys.length == 0) {
        userGradeHistory = {
          dateCreated: new Date().toISOString(),
          endDate: '',
          gradeId: user.grade,
          startDate: moment().format('YYYYMMDD'),
          status: '진행중',
          studio: user.joinStudioId,
          userId: user.id,
        };
        this.db.updateAt('gradeHistorys', userGradeHistory);
      }
      const dateofstart = moment(userGradeHistory.startDate, 'YYYYMMDD');
      const today = moment();
      const differnce = today.diff(dateofstart, 'days') + 1;
      resolve({ differnce, dateofstart });
    });
  }
  getAdmissionHistory(userId: string): Promise<any> {
    return this.db
      .collection$(`admissionHistory`, (ref) =>
        ref.where('userId', '==', userId).orderBy('dateCreated', 'desc')
      )
      .pipe(
        map((arr) => {
          let filterData = arr.filter((item) => item.endGrade);
          return filterData.map((data: any) => {
            const admissionHistory: AdmissionHistory = data;
            let gradeId = admissionHistory.endGrade
              ? admissionHistory.endGrade
              : '1111';
            let grade: Grade = this.getGradeById(gradeId);
            if (grade) {
              admissionHistory.gradeName = grade.stepName
                ? grade.gradeName + ' ' + grade.stepName
                : grade.gradeName;
            }
            return admissionHistory;
          });
        }),
        first()
      )
      .toPromise();
  }

  getUserGradeDetailByUserId(userId: string): Promise<any> {
    return this.db
      .collection$('userGradeDetails', (ref) =>
        ref.where('userId', '==', userId)
      )
      .pipe(first())
      .toPromise();
  }

  async getStudio(): Promise<any> {
    // let userId = await this.auth.uid();
    return this.db
      .collection$('studios', (ref) => ref.orderBy('dataCreated', 'desc'))
      .pipe(
        map((arr) => arr[0]),
        first()
      )
      .toPromise();
  }

  stopUser(userId: string, studioId: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.db
        .updateAt(`studios/${studioId}`, {
          stopUsers: firebase.default.firestore.FieldValue.arrayUnion(userId),
        })
        .then(() => {
          resolve('success');
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  startUser(userId: string, studioId: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.db
        .updateAt(`studios/${studioId}`, {
          stopUsers: firebase.default.firestore.FieldValue.arrayRemove(userId),
        })
        .then(() => {
          resolve('success');
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  blockUser(userId: string, studioId: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.db
        .updateAt(`studios/${studioId}`, {
          blockUsers: firebase.default.firestore.FieldValue.arrayUnion(userId),
        })
        .then(() => {
          resolve('success');
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  releaseUser(userId: string, studioId: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.db
        .updateAt(`studios/${studioId}`, {
          blockUsers: firebase.default.firestore.FieldValue.arrayRemove(userId),
        })
        .then(() => {
          resolve('success');
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getEvaluateTestDate(
    studioId: string,
    month: number,
    year: number
  ): Promise<any> {
    return this.db
      .collection$(`tests`, (ref) =>
        ref
          .where('studioId', '==', studioId)
          .where('month', '==', month)
          .where('year', '==', year)
          .orderBy('testDate', 'asc')
      )
      .pipe(
        map((data) => {
          data.map((ele) => {
            let day = moment(ele.testDate).day();
            if (day == 0) {
              ele.day = '일';
            }
            if (day == 1) {
              ele.day = '월';
            }
            if (day == 2) {
              ele.day = '화';
            }
            if (day == 3) {
              ele.day = '수';
            }
            if (day == 4) {
              ele.day = '목';
            }
            if (day == 5) {
              ele.day = '금';
            }
            if (day == 6) {
              ele.day = '토';
            }
            ele.formatDate = moment(ele.testDate).format('YYYY.MM.DD');
            return ele;
          });
          return data;
        })
      )
      .pipe(first())
      .toPromise();
  }

  getEvaluateGrades(): Promise<any> {
    return new Promise<any>(async (resolve) => {
      if (this.grades) {
        resolve(this.grades);
      } else {
        this.grades = await this.getGrades();
        resolve(this.grades);
      }
    });
  }

  getPrograms(): Promise<any> {
    return this.db
      .collection$('programs', (ref) => ref.orderBy('order', 'asc'))
      .pipe(first())
      .toPromise();
  }

  getMembership(): Promise<any> {
    return this.db
      .collection$('membership', (ref) => ref.orderBy('order', 'asc'))
      .pipe(first())
      .toPromise();
  }

  programs(): Promise<any> {
    return new Promise<any>(async (resolve) => {
      if (this.programData) {
        resolve(this.programData);
      } else {
        this.programData = await this.getPrograms();
        resolve(this.programData);
      }
    });
  }

  async gradesGroup(): Promise<any> {
    return new Promise<any>(async (resolve) => {
      let grades = await this.getGrades();
      let EduGrade = grades.filter((item) => item.isEdu);
      let groupBy = this.common.groupBy(EduGrade, 'gradeName');
      let result = Object.entries(groupBy).map(([key, value]) => ({
        key,
        value,
      }));

      resolve(result);
    });
  }

  async getGradeAlldata(): Promise<any> {
    return new Promise<any>(async (resolve) => {
      let gradesGroup = await this.gradesGroup();
      let programs = await this.programs();
      let characterEdus = await this.getCharaters();

      //무급제외
      let exceptNone = gradesGroup.filter((ele) => ele.key !== '무급');
      let allData = exceptNone.map((grade) => {
        grade.value = grade.value.map((value) => {
          let selectProgram = programs.filter(
            (item) => item.gradeId == value.id
          );
          let selectCharacterEdus = characterEdus.filter((item) =>
            item.gradeIds.find((gradeId) => gradeId == value.id)
          );
          let gradeProgram = this.common.groupBy(selectProgram, 'division');

          let result = Object.entries(gradeProgram).map(([key, value]) => ({
            key,
            value,
          }));

          return {
            ...value,
            program: result,
            characterEdus: selectCharacterEdus,
          };
        });

        return grade;
      });
      resolve(allData);
    });
  }

  pumses(): Promise<any> {
    return new Promise<any>(async (resolve) => {
      if (this.pumseData) {
        resolve(this.pumseData);
      } else {
        this.pumseData = await this.getPumses();
        resolve(this.pumseData);
      }
    });
  }

  getPumseNameById(pumseId: string) {
    if (this.pumseData) {
      let selectPumse = this.pumseData.find((item) => item.id == pumseId);
      return selectPumse.name;
    }
  }

  getPumseById(pumseId: string) {
    if (this.pumseData) {
      let selectPumse = this.pumseData.find((item) => item.id == pumseId);
      return selectPumse;
    }
  }

  getPumses(): Promise<any> {
    return this.db
      .collection$('pumses', (ref) => ref.orderBy('order', 'asc'))
      .pipe(first())
      .toPromise();
  }

  getTestUserBySection(list: any, section: any) {
    if (section.value.length == 1) {
      const sectionList = [];
      list.map((data: any) => {
        if (data.passGrade == section.value[0].id) {
          sectionList.push(data);
        }
        return data;
      });
      return sectionList;
    } else {
      const sectionList = [];
      list.map((data: any) => {
        const now = section.value.filter(
          (ele: any) => ele.id == data.passGrade
        );
        if (now && now.length > 0 && data.passGrade == now[0].id) {
          sectionList.push(data);
        }
        return data;
      });
      return sectionList;
    }
  }

  getTodayAttendances(testDate: string, userId: string) {
    return this.db
      .collection$(`attendances`, (ref: any) =>
        ref.where('date', '==', testDate).where('userId', '==', userId)
      )
      .pipe(first())
      .toPromise();
  }

  async setTablesTitle(gradesGroup, index, subIndex) {
    let endSetting = [];
    let nowGrade = gradesGroup[index];

    let tmpProgram = nowGrade.value[subIndex].program;

    tmpProgram.forEach((program: any) => {
      let setTitles = {
        title: '',
        rowSize: 0,
        colSize: 0,
        id: '',
        includeIds: [],
      };

      setTitles.title = program.key;
      setTitles.colSize = Number(program.value.length * 2);

      program.value.forEach((ele: any) => {
        setTitles.includeIds.push(ele.id);
        setTitles.title = ele.division;
        setTitles.id = ele.id;
        if (ele.divisionDesc) {
          setTitles.rowSize = 1;
        } else {
          setTitles.rowSize = 2;
        }
        if (!endSetting.includes(setTitles)) {
          endSetting.push(setTitles);
        }
      });
    });

    return endSetting;
  }

  setTableSubTitle(gradesGroup, index, subIndex) {
    let endSetting = [];
    let nowGrade = gradesGroup[index];
    let tmpProgram = nowGrade.value[subIndex].program;

    tmpProgram.forEach((program: any) => {
      program.value.forEach((ele: any) => {
        if (ele.divisionDesc) {
          let setSubTitles = {
            title: '',
            colSize: 0,
            id: '',
          };

          setSubTitles.id = ele.id;
          setSubTitles.title = ele.divisionDesc;
          setSubTitles.colSize = 2;

          if (!endSetting.includes(setSubTitles)) {
            endSetting.push(setSubTitles);
          }
        }
      });
    });
    return endSetting;
  }

  setTopics(gradesGroup, index, subIndex) {
    let endSetting = [];
    let nowGrade = gradesGroup[index];
    let tmpProgram = nowGrade.value[subIndex].program;
    tmpProgram.forEach((program: any) => {
      program.value.forEach((ele: any) => {
        let setTopics = {
          title: '',
          colSize: 2,
          id: '',
        };

        setTopics.id = ele.id;
        setTopics.title = ele.description;
        setTopics.colSize = 2;

        if (!endSetting.includes(setTopics)) {
          endSetting.push(setTopics);
        }
      });
    });
    return endSetting;
  }

  setThumbnail(gradesGroup, index, subIndex) {
    let endSetting = [];
    let nowGrade = gradesGroup[index];
    let tmpProgram = nowGrade.value[subIndex].program;

    tmpProgram.forEach((program: any) => {
      program.value.forEach((ele: any) => {
        let thumbnails = {
          img: '',
          id: '',
        };

        thumbnails.img = ele.thumbNailImage ? ele.thumbNailImage : '';
        thumbnails.id = ele.id;

        if (!endSetting.includes(thumbnails)) {
          endSetting.push(thumbnails);
        }
      });
    });

    return endSetting;
  }

  setYouTubeLink(gradesGroup, index, subIndex) {
    let endSetting = [];
    let nowGrade = gradesGroup[index];
    let tmpProgram = nowGrade.value[subIndex].program;
    tmpProgram.forEach((program: any) => {
      program.value.forEach((ele: any) => {
        let youtube = {
          link: '',
          id: '',
        };

        youtube.id = ele.id;
        youtube.link = ele.youtubeUrl ? ele.youtubeUrl : '';

        if (!endSetting.includes(youtube)) {
          endSetting.push(youtube);
        }
      });
    });
    return endSetting;
  }

  setFeedback(gradesGroup, index, subIndex) {
    let endSetting = [];
    let nowGrade = gradesGroup[index];
    let tmpProgram = nowGrade.value[subIndex].program;
    tmpProgram.forEach((program: any) => {
      program.value.forEach((ele: any) => {
        let feedBacks = {
          link: '',
          id: '',
        };

        feedBacks.id = ele.id;
        feedBacks.link = ele.feedBackLink ? ele.feedBackLink : '';

        if (!endSetting.includes(feedBacks)) {
          endSetting.push(feedBacks);
        }
      });
    });
    return endSetting;
  }

  async setPumses(gradesGroup, index, subIndex) {
    let endSetting = [];
    console.log(gradesGroup);
    let nowGroup = gradesGroup[index];

    let tmpPumse = nowGroup.value[subIndex].pumses;

    tmpPumse.forEach(async (pumse: any) => {
      let settingPumse = {
        times: pumse.times,
        id: nowGroup.value[subIndex].id,
        pumseId: pumse.pumseId,
      };

      if (!endSetting.includes(settingPumse)) {
        endSetting.push(settingPumse);
      }
    });
    return endSetting;
  }

  setAppointedPumse(gradesGroup, index, subIndex) {
    let endSetting = {
      programId: '',
      id: '',
    };
    let nowGroup = gradesGroup[index];

    endSetting.id = nowGroup.value[subIndex].essentialPumse;
    endSetting.programId = nowGroup.value[subIndex].id;

    return endSetting;
  }

  getPgPaymentData(startDate, endDate) {
    const date1 = new Date(startDate);
    date1.setDate(date1.getDate());
    date1.setHours(9, 0, 0, 0); // +9 hours for Korean Time
    const date2 = new Date(endDate);
    date2.setDate(date2.getDate() + 1);
    date2.setHours(9, 0, 0, 0); // +9 hours for Korean Time

    const start = date1.toISOString();
    const end = date2.toISOString();
    console.log('start :', start);
    console.log('end :', end);
    return this.db
      .collection$(`payment`, (ref) =>
        ref
          .where('type', 'in', ['lesson', 'notice'])
          .where('dateCreated', '>=', start)
          .where('dateCreated', '<', end)
          .orderBy('dateCreated', 'desc')
      )
      .pipe(
        leftJoinDocument(this.db.afs, 'noticeId', 'announcements'),
        leftJoinDocument(this.db.afs, 'lessonId', 'lessons'),
        leftJoinDocument(this.db.afs, 'userId', 'users'),
        leftJoinDocument(this.db.afs, 'studioId', 'studios'),
        leftJoinDocument(this.db.afs, 'lessonHistoryId', 'lessonHistory'),
        first()
      )
      .toPromise();
  }

  async getSendMessages(startDate: string, endDate: string) {
    const date1 = new Date(startDate);
    date1.setDate(date1.getDate() - 1);
    date1.setHours(9, 0, 0, 0); // +9 hours for Korean Time
    const date2 = new Date(endDate);
    date2.setDate(date2.getDate() + 1);
    date2.setHours(9, 0, 0, 0); // +9 hours for Korean Time

    const start = date1.toISOString();
    const end = date2.toISOString();
    return this.db
      .collection$('message', (ref) =>
        ref
          .where('studioId', '==', '태권바로')
          .where('dateCreated', '>=', start)
          .where('dateCreated', '<', end)
          .orderBy('dateCreated', 'desc')
      )
      .pipe(
        map((messages) => {
          const newMessages = messages.filter((user) => user.userId);
          return newMessages;
        }),
        leftJoinDocument(this.db.afs, 'userId', 'users'),
        map((messages: any) => {
          return messages.map((message) => {
            if (message.userId.name) {
              return {
                ...message,
                user: message.userId,
                type: 'user',
                studio: message.userId.joinStudioId
                  ? message.userId.joinStudioId
                  : message.userId.myStudioId
                  ? message.userId.myStudioId
                  : message.userId.myStudio,
              };
            }
            return { ...message, studio: message.userId.id, type: 'studio' };
          });
        }),
        leftJoinDocument(this.db.afs, 'studio', 'studios'),
        first()
      )
      .toPromise();
  }

  getDisplayType(studio: Studio, user: User) {
    if (studio?.blockUsers) {
      let isBlock = studio.blockUsers.find((item) => item === user?.id);
      if (isBlock) {
        return this.lang === 'ko' ? '차단회원' : 'Blocked Members';
      }
    }

    if (studio?.stopUsers) {
      let isStop = studio.stopUsers.find((item) => item === user?.id);
      if (isStop) {
        return this.lang === 'ko' ? '수련중지' : 'Suspension of Training';
      }
    }

    if (studio?.managerId) {
      let isManager = studio.managerId.find((item) => item === user?.id);
      if (isManager) {
        return this.lang === 'ko' ? '매니저' : 'Manager';
      }
    }

    let isMaster = this.checkIsMaster(user?.grade);
    if (isMaster) {
      return this.lang === 'ko' ? '교범' : 'An Instructor';
    }

    return this.lang === 'ko' ? '일반회원' : 'General Members';
  }

  getUserTraingHistorybyUserIdMonth(
    userId: string,
    month: string
  ): Promise<any> {
    const year = moment().format('YYYY');
    console.log('userId', userId);
    console.log('month', month);

    return this.db
      .collection$('trainingHistorys', (ref) =>
        ref
          .where('userId', '==', userId)
          .where('year', '==', year)
          .where('month', '==', month)
      )
      .pipe(
        map((arr) => arr && arr[0]),
        first()
      )
      .toPromise();
  }
}
